import { render } from "./SectionImageAndText.vue?vue&type=template&id=00ead5d4"
import script from "./SectionImageAndText.vue?vue&type=script&lang=js"
export * from "./SectionImageAndText.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__